import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, opacity = 1, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}px`}
    width={`${size}px`}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g stroke={color} opacity={opacity} strokeWidth="2" fill="none" fillRule="evenodd">
      <path d="m6 14 6 5 6-5M6 9l6 5 6-5M6 4l6 5 6-5" />
    </g>
  </svg>
);
